export var DataHooks = {
  title: 'title',
  subtitle: 'subtitle',
  suffix: 'suffix'
};